import React from "react";
import '../css/Style.css';
import contactimg from '../img/icons8-contact-64.png';
function Contact(){
    return(<>
         <div className="container-fluid bg-secondary mb-5">
            <div className="container py-3">
            <div class="d-flex justify-content-between ">
              <div className="fw-bold text-white  " >CONTACTUS</div>
              <div  className="fw-bold text-white ">Home > Contact</div>
                </div>
            </div>
         </div>

         <div className="container mt-5 mb-5">
         <div className="row mb-5">
          <div className="about_title">
            
            <h3 className="fw-bold bg_text">Contact Us</h3>
            <div class="fancy-border"></div>
            <p className="fs-6 text-muted p-2">We’d love to hear from you and answer any questions you may have! <br/>Send us a message using the form and we’ll respond as soon as we can</p>
          </div>
        </div>

            <div className="row">
                <div className="col-lg-6 mb-3" >
                <div class="container py-4 bg p-3 rounded slide-in-left" >
                 <img src={contactimg} />
                 <p><small className="fw-bold text-white">Fill The Bellow Fields </small></p>
                <form id="contactForm" method="POST" action="https://formspree.io/f/mdoqnakb">
                <div class="mb-4">
                   
                    <input class="form-control" id="name" name="username" type="text" placeholder="Name" required />
                </div>

                <div class="mb-4">
                    
                    <input class="form-control" id="emailAddress" name="email" required type="email" placeholder="Email Address" />
                </div>

                <div class="mb-4">
                    
                    <textarea class="form-control" name="msg" id="message" type="text" placeholder="Message" ></textarea>
                </div>

                <div class="d-grid">
                    <button class="btn bg-info text-white btn-lg" type="submit">Sent Data</button>
                </div>

                </form>

                </div>

                </div>
                <div className="col-lg-6 mb-3 mt-3 ">
                   <div className="mb-2 text-start p-2 shadow-sm rounded col-lg-8 col-xm-12 slide-in-right">
                    <address>
                    <h3 className="bg_text fs-4 fw-bold" > <i class="bi bi-phone bg text-white rounded p-1 m-1"></i>Phone</h3>
                    <p className="text-muted lead ">+91 7847869140</p>
                    </address>
                   </div>
                   <div className="mb-2 text-start p-2 shadow-sm rounded col-lg-8 col-xs-12 slide-in-right1">
                    <address>
                    <h3 className="bg_text fs-4 fw-bold" > <i class="bi bi-envelope bg text-white rounded p-1 m-1"></i>Email</h3>
                    <p className="text-muted lead ">swaynnarayan@gmail.com</p>
                    </address>
                   </div>
                   <div className="mb-2 text-start p-2 shadow-sm rounded col-lg-8 col-xs-12 slide-in-right2 ">
                    <address className="text-muted">
                    <h3 className="bg_text fw-bold fs-4 pt-2" ><i class="bi bi-map bg text-white rounded p-1 m-1"></i>Address</h3>
                   <span className=" lead text-muted">
                   Biripur, Gobara, <br/>
                    Odisha 761124
                   </span>
                    </address>
    
                   </div>
                </div>

            </div>

         </div>

         <div className="container-fluid">
         <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3753.165320357941!2d84.59442677391088!3d19.83295668153372!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a22c180dba1588b%3A0x1c82766e3e94fff1!2sFruits%20Shop!5e0!3m2!1sen!2sin!4v1702798633011!5m2!1sen!2sin" width="100%" height="350"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

         </div>
    </>);
}
export default Contact;